export default __webpack_public_path__ + "static/media/recent-activity-artwork-1.39e06cc4.png";